"use client";

import { useLocale, useTranslations } from "next-intl";

const EVENTS_HOSTED = 11_500;
const MEMORIES_COLLECTED = 4_600_000;

export default function SocialProofBar(): React.ReactElement | null {
  const t = useTranslations("Index.SocialProof");
  const locale = useLocale();
  const numberFormatter = new Intl.NumberFormat(locale);

  // The English review found no dated source for these counts or the #1
  // claim. Keep them out of public copy until that evidence is available.
  if (locale === "en") return null;

  return (
    <div className="w-full max-w-screen-lg mx-auto px-4">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 sm:gap-12 py-6">
        <div className="text-center">
          <p className="text-3xl md:text-4xl font-bold text-primary">
            {numberFormatter.format(EVENTS_HOSTED)}
          </p>
          <p className="font-medium mt-1">{t("events")}</p>
          <p className="text-sm text-muted-foreground mt-0.5">{t("eventsSubtitle")}</p>
        </div>
        <div className="text-center">
          <p className="text-3xl md:text-4xl font-bold text-primary">
            {numberFormatter.format(MEMORIES_COLLECTED)}
          </p>
          <p className="font-medium mt-1">{t("memories")}</p>
          <p className="text-sm text-muted-foreground mt-0.5">{t("memoriesSubtitle")}</p>
        </div>
        <div className="text-center">
          <p className="text-3xl md:text-4xl font-bold text-primary">{t("rankingNumber")}</p>
          <p className="font-medium mt-1">{t("ranking")}</p>
          <p className="text-sm text-muted-foreground mt-0.5">{t("rankingSubtitle")}</p>
        </div>
      </div>
    </div>
  );
}
